import { isDigit } from 'ldash';
import { log } from 'uix/logging';
import { decodeSlimLink } from 'uix/utils';
export const ancestorAxis = {
    cacheKeys: {
        keys: [
            'dname',
            'id'
        ],
        // non-numeric ids (j123 - a job id) should be cached with null form
        // slimlinks should be allowed
        keymod: (keyData)=>decodeSlimLink(keyData.id).otid || isDigit(keyData.id) ? keyData : {
                ...keyData,
                id: null
            }
    },
    type: 'ancestorAxisJson'
};
export const treeAspect = {
    layout: 'L131Split',
    context: 'treeid',
    filters: [
        ancestorAxis
    ],
    acl: 'g:admin,g:qs',
    parts: [
        {
            type: 'AdminTree',
            align: 'left',
            acl: '-c:vlm'
        },
        {
            type: 'AdminHeader',
            align: 'centerTop',
            acl: '-c:vlm'
        },
        //~ {type: 'TestTree', align: 'right', acl: '-c:vlm'},
        {
            type: 'TreeTopTabs',
            align: 'center',
            cssClass: 'noCenterFlex',
            order: -99,
            acl: '-c:vlm'
        },
        {
            type: 'MajorTabGroup',
            align: 'center',
            cssClass: 'noCenterFlex',
            order: 99,
            acl: '-c:vlm'
        }
    ]
};
export const treeAspectMinorTabgroup = {
    ...treeAspect,
    parts: [
        ...treeAspect.parts,
        {
            type: 'MinorTabGroupBottom',
            align: 'center',
            order: 99
        }
    ]
};
export const wikiTab = ({ ident, ...props })=>({
        datatype: [
            10
        ],
        parts: [
            {
                showMenu: true,
                type: 'Wikiblock',
                name: `Wiki${ident}`,
                filters: [
                    {
                        ident: `${ident}!`,
                        type: 'getWikiRendered'
                    }
                ]
            }
        ],
        ...props
    });
export const customizeJobRouting = (request, query, oldreq)=>{
    let deletable_id = request.id == oldreq.id && (request.dname !== oldreq.dname || request.classname !== 'job' && request.tabname !== oldreq.tabname || request.classname !== oldreq.classname);
    // log.x(deletable_id)
    return deletable_id && String(request.id).startsWith('j') ? {
        request: {
            id: null
        }
    } : {};
};
export const jobTab = ({ names, jobButton, ...props })=>({
        datatype: [
            10
        ],
        parts: [
            {
                type: 'JobList',
                jobButton,
                embeddedInfo: true,
                filter_names: names
            }
        ],
        customizeRouting: customizeJobRouting,
        ...props
    });
export const isBadType2 = (datatype, subtype)=>datatype == 2 && (subtype == 52 || subtype == 9 || subtype == 53);
export const isRootDomainConfig = ({ dname, iconfig })=>iconfig.domain.rootDomain == dname;
export const isDomainRecord = ({ datatype })=>datatype == 10;
